import * as React from "react"
import { Col, Row } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../atoms/spacers"
import { MediaQuery } from "../../utils/design-helpers"
import Card from "../atoms/Card"
import Subtitle from "../atoms/typography/Subtitle"
import { BookmarkActiveIcon } from "../atoms/icons/BookmarkIcons"
import ReceiptCard from "../molecules/ReceiptCard"
import H3 from "../atoms/typography/H3"
import { Order } from "../../utils/models"

export interface Receipt {
  id: number
  previewSrc: string
  title: string
  order?: Order
  readableOrderType: string
  date: any
  bookmarked?: boolean
  receiptUrl: string
  buyer?: string
}

interface Props {
  receipts: Array<Receipt>
}

const TitleRow = styled(Row)`
  padding: 0.5rem 1rem;
`

const ContentContainer = styled.div`
  padding-left: 3rem;
  padding-right: 3rem;

  ${MediaQuery.XS} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`

const ReceiptsCard: React.FunctionComponent<Props> = ({ receipts }) => {
  const bookmarkedReceipts = receipts.filter((x) => x.bookmarked === true)

  return (
    <Card>
      <ContentContainer>
        {bookmarkedReceipts.length > 0 && (
          <>
            <HorizontalSpacer spacing={1} />
            <TitleRow justify="between" align="center">
              <div>
                <Subtitle>
                  <BookmarkActiveIcon /> Bookmarked receipts
                </Subtitle>
              </div>
              {/*<PrimaryButton
                title='Download all'
                icon={<DownloadIcon size={24} />}
              />*/}
            </TitleRow>
            <HorizontalSpacer spacing={1} />
          </>
        )}
        <Row>
          {bookmarkedReceipts.map((receipt) => (
            <Col lg={6} md={12} xs={12} key={receipt.id} style={{ padding: 16 }}>
              <ReceiptCard
                id={receipt.id}
                previewSrc={receipt.previewSrc}
                title={receipt.title}
                readableOrderType={receipt.readableOrderType}
                date={receipt.date}
                bookmarked={receipt.bookmarked}
                receiptUrl={receipt.receiptUrl}
                order={receipt.order}
                buyer={receipt.buyer}
              />
            </Col>
          ))}
        </Row>
        <HorizontalSpacer spacing={3} />
        <TitleRow justify="between" align="center">
          <Subtitle>All receipts</Subtitle>
          {/*<PrimaryButton
            title='Download all'
            icon={<DownloadIcon size={24} />}
          />*/}
        </TitleRow>
        <HorizontalSpacer spacing={0.5} />

        {receipts.length < 1 && (
          <H3>
            <HorizontalSpacer spacing={2} />
            No receipts. When you make a purchase, your receipt can be found here.
          </H3>
        )}

        <Row>
          {receipts.map((receipt) => (
            <Col lg={6} md={12} xs={12} style={{ padding: 16 }} key={receipt.id}>
              <ReceiptCard
                id={receipt.id}
                previewSrc={receipt.previewSrc}
                title={receipt.title}
                readableOrderType={receipt.readableOrderType}
                date={receipt.date}
                bookmarked={receipt.bookmarked}
                receiptUrl={receipt.receiptUrl}
                order={receipt.order}
                buyer={receipt.buyer}
              />
            </Col>
          ))}
        </Row>
      </ContentContainer>
      <HorizontalSpacer spacing={1} />
    </Card>
  )
}

export default ReceiptsCard
